import { useEffect, useState } from "react";
import BrowsingCard from "../../components/BrowsingCard";
import { MagnifyingGlassIcon, FunnelIcon, XMarkIcon, ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/24/solid";
import NavBar from "../../components/Navigation/NavBar";
import Footer from "../../components/Footer/Footer";
import { getApprovedSellWithUser } from "../../services/firestore/sellService";

function SellHomePage() {
  const [search, setSearch] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [sells, setSells] = useState([]);
  const ITEMS_PER_PAGE = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const toggleFilters = () => setShowFilters(prev => !prev);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })

    useEffect(() => {
      const fetchData = async () => {
        const data = await getApprovedSellWithUser();
        setSells(data);
      };
      fetchData();
    }, []);

    const paginatedSells = sells.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const totalPages = Math.ceil(sells.length / ITEMS_PER_PAGE);
  return (
    <>
      <NavBar />

      <div className="p-4 max-w-7xl mx-auto mt-20">
        <nav class="flex pb-4" aria-label="Breadcrumb">
          <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
            <li class="inline-flex items-center">
              <a href="/" class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-600">
                <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
                </svg>
                Home
              </a>
            </li>
            <li>
              <div class="flex items-center">
                <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4" />
                </svg>
                <a class="ms-1 text-sm font-medium md:ms-2 text-gray-400 ">Sell</a>
              </div>
            </li>

          </ol>
        </nav>
        {/* Search Section */}
        {/* <div className="flex items-center gap-2 mb-6">
    <input
      type="text"
      placeholder="Search..."
      className="flex-1 px-4 py-2 border rounded-lg"
    />
    <button className="p-2 bg-gray-100 rounded-lg">
      <MagnifyingGlassIcon className="w-5 h-5 text-gray-600" />
    </button>
    <button className="p-2 bg-gray-100 rounded-lg">
      <FunnelIcon className="w-5 h-5 text-gray-600" />
    </button>
    
  </div> */}

        {/* <div className="relative">
          <div className="flex items-center gap-2 mb-6">
            <input
              type="text"
              placeholder="Search..."
              className="flex-1 px-4 py-2 border rounded-lg"
            />
            <button className="p-2 bg-gray-100 rounded-lg">
              <MagnifyingGlassIcon className="w-5 h-5 text-gray-600" />
            </button>
            <button
              className="p-2 bg-gray-100 rounded-lg relative"
              onClick={toggleFilters}
            >
              <FunnelIcon className="w-5 h-5 text-gray-600" />
            </button>
          </div>

          {showFilters && (
            <div className="absolute right-0 z-10 mt-[-1rem] w-80 bg-white shadow-lg border rounded-xl p-4 space-y-4">
              
              <div>
                <label className="font-medium block mb-1">Price Range</label>
                <div className="flex gap-2">
                  <input
                    type="number"
                    placeholder="Min"
                    className="w-full border rounded px-2 py-1"
                  />
                  <input
                    type="number"
                    placeholder="Max"
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
              </div>

             
              <div>
                <label className="font-medium block mb-1">Category</label>
                <select className="w-full border rounded px-2 py-1">
                  <option>All</option>
                  <option>Electronics</option>
                  <option>Books</option>
                  <option>Fashion</option>
                  <option>Home & Living</option>
                </select>
              </div>

              
              <div>
                <label className="font-medium block mb-1">Ratings</label>
                <div className="flex gap-4">
                  {[5, 4, 3].map(star => (
                    <label key={star} className="flex items-center gap-1">
                      <input type="radio" name="rating" value={star} />
                      {star}★
                    </label>
                  ))}
                </div>
              </div>

              
              <div className="flex items-center gap-2">
                <input type="checkbox" id="available" />
                <label htmlFor="available" className="text-sm">Only show available items</label>
              </div>

            
              <div className="flex justify-between">
                <button className="px-3 py-1 bg-gray-200 rounded">Reset</button>
                <button className="px-3 py-1 bg-blue-600 text-white rounded">Apply</button>
              </div>
            </div>
          )}
        </div>

        <div className="flex flex-wrap gap-2 mb-4">
          <span
            className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
          >
            $10 - $500
            <button
              className="ml-1 hover:text-red-500"
            >
              <XMarkIcon className="w-3 h-3" />
            </button>
          </span>
          <span
            className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
          >
            Bags
            <button
              className="ml-1 hover:text-red-500"
            >
              <XMarkIcon className="w-3 h-3" />
            </button>
          </span>
        </div> */}
        {/* Items Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {paginatedSells.map((item, idx) => (
            <BrowsingCard key={idx} item={item} />
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
        <div className="flex flex-1 justify-between sm:hidden">
          <a
            href="#"
            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Previous
          </a>
          <a
            href="#"
            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Next
          </a>
        </div>
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Showing <span className="font-medium">1</span> to <span className="font-medium">10</span> of{' '}
              <span className="font-medium">97</span> results
            </p>
          </div>
          <div>
            <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-xs">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              >
                <ChevronLeftIcon aria-hidden="true" className="size-5" />
              </button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ${currentPage === i + 1
                      ? "z-10 bg-indigo-600 text-white"
                      : "text-gray-900 hover:bg-gray-50"
                    }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              >
                <ChevronRightIcon aria-hidden="true" className="size-5" />
              </button>
            </nav>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SellHomePage;